@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

$var-displayStatusBorderRadius: 4px;

.label {
	display: flex;
	flex-flow: column;
	align-items: center;
	background-color: Colors.$col-greyBackground;
	border-radius: $var-displayStatusBorderRadius;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-xs;
	user-select: none;
	text-transform: capitalize;
	font-size: Constants.$val-fontSizeSmall;
	font-weight: bold;
	color: Colors.$col-white;
	width: 120px;

	&__active {

		&--to-do {
			color: Colors.$col-greyFontLight;
		}

		&--in-progress {
			color: Colors.$col-blackDark;
		}

		&--pending-superintendent {
			background-color: Colors.$col-orange;
		}

		&--pending-management {
			background-color: Colors.$color-blue;
		}

		&--pending-accounting {
			background-color: Colors.$color-eggplant;
		}

		&--changes-requested {
			background-color: Colors.$col-canceledRed;
		}

		&--finalizing {
			background-color: Colors.$color-green;
		}

		&--done {
			color: Colors.$color-green;
		}

		&--submitted {
			color: Colors.$color-green;
		}
	}

	&__inactive {

		&--to-do {
			color: Colors.$col-greyFontLight;
		}

		&--in-progress {
			color: Colors.$col-blackDark;
		}

		&--pending-superintendent {
				color: Colors.$col-orange;
		}

		&--pending-management {
				color: Colors.$color-blue;
			}

		&--pending-accounting {
			color: Colors.$color-eggplant;
		}
		
		&--changes-requested {
			color: Colors.$col-canceledRed;
		}

		&--finalizing {
			color: Colors.$color-green;
		}

		&--done {
			color: Colors.$color-green;
		}

		&--submitted {
			color: Colors.$color-green;
		}
	}
	
}

.label-condensed-view {
	background-color: Colors.$col-greyBackground;
	display: flex;
	align-items: center;
	border-radius: $var-displayStatusBorderRadius;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	user-select: none;
	text-transform: capitalize;
	font-size: Constants.$val-fontSizeSmall;
	font-weight: bold;
	color: Colors.$col-white;
	flex-flow: column;

	&__active {

		&--to-do {
			color: Colors.$col-greyFontLight;
		}

		&--in-progress {
			color: Colors.$col-blackDark;
		}

		&--pending-superintendent {
			background-color: Colors.$col-orange;
		}

		&--pending-management {
			background-color: Colors.$color-blue;
		}

		&--pending-accounting {
			background-color: Colors.$color-eggplant;
		}

		&--changes-requested {
			background-color: Colors.$col-canceledRed;
		}

		&--finalizing {
			background-color: Colors.$color-green;
		}

		&--done {
			color: Colors.$color-green;
		}

		&--submitted {
			color: Colors.$color-green;
		}
	}

	&__inactive {

		&--to-do {
			color: Colors.$col-greyFontLight;
		}

		&--in-progress {
			color: Colors.$col-blackDark;
		}

		&--pending-superintendent {
			color: Colors.$col-orange;
		}

		&--pending-management {
			color: Colors.$color-blue;
		}

		&--pending-accounting {
			color: Colors.$color-eggplant;
		}
		
		&--changes-requested {
			color: Colors.$col-canceledRed;
		}

		&--finalizing {
			color: Colors.$color-green;
		}

		&--done {
			color: Colors.$color-green;
		}

		&--submitted {
			color: Colors.$color-green;
		}
	}
}

.dropdown-option {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	font-size: Constants.$val-fontSizeSmall;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap; 
	width: fit-content;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
}
